<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F3F4F6" />
    <circle
      cx="20.0003"
      cy="20"
      r="9.00375"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.9995 23.5015H21.3098"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.1593 23.5015V19.2497H19.0088"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.0999 16.2457C20.0999 16.3838 19.9879 16.4958 19.8498 16.4958C19.7117 16.4958 19.5997 16.3838 19.5997 16.2457C19.5997 16.1076 19.7117 15.9956 19.8498 15.9956"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.8503 15.9956C19.9884 15.9956 20.1004 16.1076 20.1004 16.2457"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
